import React from "react";

interface PreviewMessageWaProps {
    header: any;
    body: any;
    footer: any;
    buttons: any;
}
function PreviewMessageWa({ header, body, footer, buttons }: PreviewMessageWaProps) {

    
  return (
    <div className="mt-3 ">
        <div className="preview-template">
            { header && header.format === 'TEXT' &&  <div className="preview-template-header">{header.text}</div> }
            { header && header.format === 'IMAGE' &&  <div className="preview-template-header"><div className="preview-template-image" style={{ backgroundImage: `url(${header.image})`}}>{ !header.image && <i className="bi-card-image"></i> }</div></div> }
            { header && header.format === 'VIDEO' &&  <div className="preview-template-header"> <div className="preview-template-video" > <i className="bi-play-circle-fill"></i></div> </div> }
            { header && header.format === 'DOCUMENT' &&  <div className="preview-template-header"> <div className="preview-template-video" > <i className="bi-filetype-pdf"></i></div> </div> }
            { body && <div dangerouslySetInnerHTML={{__html: body.text.replace(/\n/g, '<br/>') }}></div> }
            { footer && <div className="preview-template-footer">{footer.text}</div>}
        </div>

        {
            buttons && (
                <div className="">
                    {
                        buttons.buttons.map( (btn, index) => (
                            <div key={index} className="preview-template preview-template-btn">
                                { btn.type === 'URL' && <><i className="bi bi-box-arrow-up-right"></i> {btn.text}</>}
                                { btn.type === 'QUICK_REPLY' && <><i className="bi bi-reply"></i> {btn.text}</>}
                            </div>)
                        )
                    }
                </div>
            )
        }
        
    </div>
  );
}

export default PreviewMessageWa;
